import eventBus from './eventBus';

export default {
  init() {
    window.onParentMessage = (message, payload) => {
      const modifiedData = JSON.stringify(payload);
      const data = JSON.parse(modifiedData);
      eventBus.$emit(message, data);
    };
  },
  isActive() {
    return navigator.userAgent.includes('wv');
  },
};
